import api from "../../../utils/api";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { Invoice } from "../../../@types/invoice";

const findPendingInvoicesByClientIdentifier = createAsyncThunk(
  "paymentNoticeDetail/findPendingInvoicesByClientIdentifier",
  async (clientIdentifier: string, { rejectWithValue }) => {
    try {
      const url = new URL(`${api.baseURL}invoice/find-pending-by-client-identifier`);
      url.searchParams.append("clientIdentifier", clientIdentifier);
      const token = localStorage.getItem("token");
      const headers = new Headers();
      headers.append("Authorization", `Bearer ${token}`);
      headers.append("Content-Type", "application/json");

      let response = await fetch(url.toJSON(), {
        method: "POST",
        headers: headers,
      });
      if (!response.ok) {
        throw response.statusText;
      }
      let data = await response.json();
      return data.map((invoice: Invoice) => ({
        ...invoice,
        payedAmountAtCurrentPaymentNotice: 0,
      }));
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export default findPendingInvoicesByClientIdentifier;
